import { render } from "./UsageStats.vue?vue&type=template&id=ab40a8a2&scoped=true"
import script from "./UsageStats.vue?vue&type=script&lang=js"
export * from "./UsageStats.vue?vue&type=script&lang=js"

import "./UsageStats.vue?vue&type=style&index=0&id=ab40a8a2&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab40a8a2"]])

export default __exports__